import { Button } from '@/components/ui/button';
import { NoteText } from './NoteText';
export function NoteConflict({ note, onReviewed }: { note: any; onReviewed: () => void }) {
  if (!note) return null;
  return (
    <div role="alert" className="space-y-2 rounded-lg border border-amber-500 p-3 text-sm">
      <p className="font-semibold">This note was edited elsewhere</p>
      <p>Review the latest saved note. Your draft is still below.</p>
      <div className="max-h-48 overflow-y-auto rounded bg-muted p-3">
        <NoteText text={note.text} mentions={note.mentions} />
      </div>
      <Button variant="outline" size="sm" onClick={onReviewed}>
        Continue with my draft
      </Button>
    </div>
  );
}
